function g(h, c, r, n) {
  var e = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: h === "horizontal" ? c.x - e : r.left + 0.5,
    y: h === "horizontal" ? r.top + 0.5 : c.y - e,
    width: h === "horizontal" ? n : r.width - 1,
    height: h === "horizontal" ? r.height - 1 : n
  };
}
export {
  g as getCursorRectangle
};
